import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useOktaAuth } from "@okta/okta-react";
import { OLButton } from "OLButton";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useNotifications } from "contexts/Toast/ToastProvider";
import { useAuth } from "hooks/auth";
import { useMessage } from "hooks/intl";
import { useEffect } from "react";
import { links } from "utilities/links";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    authLink: {
      marginTop: theme.spacing(8),
    },
  }),
);

export function OKTALoginButton() {
  const classes = useStyles();
  const { message } = useMessage();
  const { loginWithMA } = useAuth();
  const { notify } = useNotifications();

  const { authState, oktaAuth } = useOktaAuth();
  const loginOkta = () =>
    oktaAuth.signInWithRedirect({ originalUri: links.oktaLoginCallback });

  useEffect(() => {
    if (
      authState?.isAuthenticated &&
      authState?.accessToken?.accessToken &&
      message({ id: "loginSuccessful" }) !== "loginSuccessful"
    ) {
      const login = async () => {
        try {
          loginWithMA(`${authState?.accessToken?.accessToken}`);
          notify(message({ id: "loginSuccessful" }));
        } catch (error) {
          message({ id: "unknownErrorDuringLogin" });
        }
      };

      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, message]);

  return (
    <OLButton
      className={classes.authLink}
      color="primary"
      fullWidth
      onClick={() => loginOkta()}
      size="large"
      type="submit"
      variant="outlined"
    >
      {message({ id: "continueWithSSO" })}
    </OLButton>
  );
}
